import { render, staticRenderFns } from "./CustomerAction.vue?vue&type=template&id=60ab1bee&"
import script from "./CustomerAction.vue?vue&type=script&lang=js&"
export * from "./CustomerAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports